import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "toggle__container" }
const _hoisted_2 = { class: "toggle__input-container" }
const _hoisted_3 = ["name", "id", "disabled"]
const _hoisted_4 = ["for"]
const _hoisted_5 = {
  key: 0,
  class: "error-message"
}

import { useIdGenerator } from '@/shared/designsystem/useIdGenerator';
import { useVModel } from '@vueuse/core';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-toggle',
},
  __name: 'toggle',
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  id: {
    type: String,
  },
  errorMessage: {
    type: String,
  },
  name: {
    type: String,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  hideLabel: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue", "change"],
  setup(__props, { emit: __emit }) {



const props = __props;

const { inputId } = useIdGenerator(props.id);

const emit = __emit;
const value = useVModel(props, 'modelValue', emit);

function handleToggleClick() {
  if (!props.disabled) {
    emit('update:modelValue', !value.value);
    emit('change', !value.value);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["n-input", { 'has-error': __props.errorMessage }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
          name: __props.name,
          id: _unref(inputId),
          disabled: __props.disabled,
          onChange: _cache[1] || (_cache[1] = ($event: any) => (emit('change', _unref(value))))
        }, null, 40, _hoisted_3), [
          [_vModelCheckbox, _unref(value)]
        ]),
        _createElementVNode("div", {
          class: "toggle",
          onClick: handleToggleClick
        }, _cache[2] || (_cache[2] = [
          _createElementVNode("div", { class: "toggle-inner" }, null, -1)
        ]))
      ]),
      _createElementVNode("label", {
        for: _unref(inputId),
        class: _normalizeClass({ 'sr-only': __props.hideLabel })
      }, _toDisplayString(__props.label), 11, _hoisted_4)
    ]),
    (__props.errorMessage)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.errorMessage), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})